import React, { useEffect, useRef, useState } from 'react';
import NullPlayer from '../../assets/img/player/null.png';

function SearchListForMain({data}) {    
    useEffect(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        window.addEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        })
    }, []);

    function positionCheckForKr(positionTypeCode) {
        if(positionTypeCode*1 === 5201 || positionTypeCode*1 === 5211) return '투수';
        else return '타자';
    }   

    function handCheck(hand) {
        if(hand ==='R') return '우';
        else return '좌';
    }

    const playerProfileHandler = (event) => {
        let id = event.currentTarget.id;

        let idSplit = id.split('_');
        let positionTypeCode = idSplit[0];
        let playerId = idSplit[1];

        let playerType = (positionTypeCode*1 === 5201 || positionTypeCode*1 === 5211) ? 'pitcher' : 'batter';
        window.location.href = '/'+playerType+"/"+playerId;
    }

    function onErrorHandler(event) {
        event.target.src = NullPlayer;
    }

    return (
        <>
        {
        data.map((profile) => (
            <div className="search_player_item" id={profile['positionTypeCode']+"_"+profile['membersId']} key={profile['membersId']} onClick={playerProfileHandler}>
                <div className="leftDiv">
                    <img className="profileImg" src={`http://image.hanwha.kbostat.net/profileImage/${profile['membersId']}.jpg`}
                        alt="#" onError={onErrorHandler} />
                </div>
                <div className="rightDiv">
                    <div className="title">{profile['membersName']} No.{profile['backnumber']}</div>
                    <div className="content">
                        {profile['teamName']} {positionCheckForKr(profile['positionTypeCode'])} {handCheck(profile['pitchingHand'])}투{handCheck(profile['battingHand'])}타
                    </div>
                </div>
            </div>   
        ))
        }
        </>
    )
}

export default SearchListForMain;